import React from 'react'
import Fingerprint2 from 'fingerprintjs2'

import App from 'App'
import {apiMethodsWithFingerprint} from 'services/api'
import Loader from 'components/Loader'
import GlobalContexts from 'GlobalContexts'

const FingerprintGetter = () => {
  const [fingerprint, setFingerprint] = React.useState(undefined)

  React.useEffect(() => {
    if (window.requestIdleCallback) requestIdleCallback(fingerprint2get)
    else setTimeout(fingerprint2get, 500)
  }, [])

  const fingerprint2get = () => Fingerprint2.getV18(result => {
    if (!result) result = Math.random().toString()
    setFingerprint(result)
    apiMethodsWithFingerprint.fingerprint = result
  })

  return fingerprint === undefined ? <Loader/> : <GlobalContexts><App/></GlobalContexts>
}

export default FingerprintGetter
